/*
 *
 * RegAttemptsExceededModal
 *
 * @version 1.0.0
 * @author NEOSYN\user
 * @since 08-Oct-2024
 */

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import RegAttemptsExceededModal from './RegAttemptsExceededModal'
import { doHidePopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  doHidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(RegAttemptsExceededModal)
